'use strict';

import config from '../../js/config';
import cookies from 'js-cookie';
import { EnableFECacheCookie } from '../../utilities/featureFlags';

class CacheCookieHelper {

  constructor() {
  }

  initialize() {
    this._cookieConfigString = config.cacheCookieSettings.cookies;
    this._maxAge = config.cacheCookieSettings.maxAge;
  }

  parseConfig() {
    let cookieConfigCacheArray = this.parseCookieString(this._cookieConfigString);
    let resultCookieCacheArray = [];
    let innerCookieValueArray = [];
    let cookieCacheString = '';

    //Creates an Array of Cookies with flattened multi-key cookie value
    if (cookieConfigCacheArray && cookieConfigCacheArray.length > 0) {
      for (var i = 0; i < cookieConfigCacheArray.length; i++) {
        let cookieValue = this.getCookieValue(cookieConfigCacheArray[i].name);
        if (cookieValue.indexOf('=') > 1) {
          innerCookieValueArray = this.parseCookieString(cookieValue);
          if (innerCookieValueArray && innerCookieValueArray.length > 0) {
            innerCookieValueArray.forEach((item) => {
              let configItemValue = cookieConfigCacheArray.find(configItem => configItem.name === item.name);
              if (configItemValue) {
                resultCookieCacheArray.push({ name: item.name, alias: configItemValue.value, value: item.value });
              } else {
                resultCookieCacheArray.push({ name: item.name, alias: item.name, value: item.value });
              }
            });
          }
          cookieValue = 'EMPTY';
        }

        let exisitingItem = resultCookieCacheArray.find(configItem => configItem.name === cookieConfigCacheArray[i].name);
        if (exisitingItem === null || exisitingItem === undefined) {
          resultCookieCacheArray.push({ name: cookieConfigCacheArray[i].name, alias: cookieConfigCacheArray[i].value, value: cookieValue });
        }
      }

      // Sorts Cookie array and builds arrow cache string.
      resultCookieCacheArray.sort((a, b) => (a.alias.toLowerCase() > b.alias.toLowerCase()) ? 1 : ((b.alias.toLowerCase() > a.alias.toLowerCase()) ? -1 : 0));
      for (var i = 0; i < resultCookieCacheArray.length; i++) {
        let item = resultCookieCacheArray[i];
        if (i === (resultCookieCacheArray.length - 1)) {
          cookieCacheString += item.alias + '=' + item.value;
        } else {
          cookieCacheString += item.alias + '=' + item.value + '&';
        }
      }
    }
    return cookieCacheString;
  }

  getCookieValue(cookieName) {
    let cookieList = cookies.get();
    let cookieValue = cookies.get(cookieName)

    if (cookieValue === '') {
      cookieValue = cookieList[cookieName];
    }

    return cookieValue ? cookieValue : 'EMPTY';
  }

  parseCookieString(cookieString) {
    let cookieCacheArray = [];
    if (cookieString) {
      cookieString.split('&').forEach(function(x) {
        let arr = x.split('=');
        cookieCacheArray.push({ name: arr[0], value: arr[1] });
      });
    }

    return cookieCacheArray;
  }

  setCacheCookie() {
    if (EnableFECacheCookie.isEnabled()) {
      this._cacheCookieString = this.parseConfig();
      let cacheCookie = cookies.get(config.cookies.arrowCache);
      if (cacheCookie && this._cacheCookieString && this._cacheCookieString.length > 0 && this._cacheCookieString !== cacheCookie) {
        cookies.set(
          config.cookies.arrowCache,
          this._cacheCookieString,
          {
            domain: config.cookies.domain,
            expires: Math.round(this._maxAge / 86400)
          }
        );
      }
    }
    else {
      let cacheCookie = cookies.get(config.cookies.arrowCache);
      if (cacheCookie) {
        cookies.remove(config.cookies.arrowCache);
      }
    }
  }
}

module.exports = new CacheCookieHelper();



// WEBPACK FOOTER //
// ./assets/components/CacheCookieHelper/CacheCookieHelper.js